<template>
    <div class="offer-box full-width">
    
        <img class="october_image"  src="/images/enroll_bonus_october.jpg" alt="Ulta" >
        <div class="copy">
            <p class="fs-3">To unlock your exclusive deals on shopping, dining, and more, follow the four easy steps below:</p>
            <p class="fs-3">1. Join Beyond Ulta Beauty Rewards<sup class="small-trademark">&#8482;</sup></p>
            <p class="fs-3">2. Add your Ulta Beauty Rewards<sup class="small-trademark">&trade;</sup> Mastercard<sup class="small-trademark">&reg;</sup> Credit Card number</p>
              <p class="fs-3">3. Activate offers and use your credit card to earn cash back paid as a statement credit</p>
             <p class="fs-3">4. Exclusively this month, earn 150 bonus points when you enroll by Oct. 31, 2023</p>
        </div>
        
    </div>
</template>

<script>
    export default {
        name: "PromotionalComponentOctober",
    }
</script>
<style> 

 .october_image {
    width:35%
  }
@media (max-width: 650px) {
  .october_image {
    width:100%
  }
   .small-trademark {
    font-size: 1rem; 
  }
}
</style>
